/* sliders */
function scrollSlider(id,dir){
  const el=document.getElementById(id);
  el.scrollBy({left:dir*300,behavior:'smooth'});
}
function filterShop(cat,btn){
  document.querySelectorAll('#shop-slider .m-card').forEach(c=>{
    c.style.display=(cat==='all'||c.dataset.cat===cat)?'flex':'none';
  });
  btn.parentElement.querySelectorAll('.pill').forEach(p=>p.classList.remove('on'));
  btn.classList.add('on');
}

/* Setup builder → cart (18 Aug 2026, replaces the old "Make it yours" →
   chat-panel handoff now that the custom WhatsApp/Email panel is gone —
   see the removal note by the profile picker below). Adds the picked
   machine, and grinder if this pairing has a separate one, straight to
   the real cart as two line items at their real prices — no bundle
   discount, since these 9 pairings aren't backed by an actual bundle SKU
   (only the 4 products on the Combos page are). Reads window.sacgSetupSelection,
   which paint() below keeps stocked with the real variant id(s) for
   whatever's currently on screen. */
function addSetupToCart(btn){
  var setup=window.sacgSetupSelection;
  if(!setup || !setup.mVariantId){
    if(btn) btn.textContent="Sorry, try again";
    return;
  }
  var items=[{id:setup.mVariantId, quantity:1}];
  if(setup.gVariantId) items.push({id:setup.gVariantId, quantity:1});
  var original=btn?btn.textContent:"";
  if(btn){ btn.disabled=true; btn.textContent="Adding…"; }
  fetch("/cart/add.js",{
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify({items:items})
  }).then(function(r){ if(!r.ok) throw new Error("add failed"); return r.json(); })
    .then(function(){ window.location.href="/cart"; })
    .catch(function(){
      if(btn){ btn.disabled=false; btn.textContent=original||"Make it yours"; }
      alert("Sorry, something went wrong adding this to your cart — please try again, or WhatsApp us on 079 252 9299.");
    });
}

/* mouse parallax */
(function(){
  if(matchMedia('(hover: none)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const els=[...document.querySelectorAll('.px')];
  let raf=null, mx=0, my=0;
  window.addEventListener('mousemove',e=>{
    mx=(e.clientX/innerWidth)-.5; my=(e.clientY/innerHeight)-.5;
    if(!raf) raf=requestAnimationFrame(()=>{ raf=null;
      els.forEach(el=>{const d=+el.dataset.px||8; el.style.transform=`translate3d(${(-mx*d).toFixed(1)}px, ${(-my*d*.7).toFixed(1)}px, 0)`;});
    });
  });
})();

/* scroll reveal */
(function(){
  const targets=[...document.querySelectorAll('.rv')];
  if(!targets.length) return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){ targets.forEach(t=>t.classList.add('in')); return; }
  const io=new IntersectionObserver(entries=>{
    entries.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
  },{threshold:0.12, rootMargin:'0px 0px -6% 0px'});
  targets.forEach(t=>io.observe(t));
})();

/* journey: the big counter photo pins on screen (sticky inside a tall
   wrapper). While pinned it first HOLDS fully intact so you can take in the
   setup, then eases slightly smaller, then cracks into three blocks, each
   crossfading into its persona machine (Bianca / Linea Mini R / Meraki)
   with the card text last. Fully scroll-scrubbed on desktop — scrolling
   back up runs the whole thing in reverse and recomposes the photo. On
   mobile the scrubbed version read shaky (mobile browsers resize the
   viewport as the URL bar collapses mid-scroll), so there .jbreak is
   TOGGLED at two scroll thresholds with a wide hysteresis gap: break as
   the photo nears mid-screen, recompose when scrolled back up above it.
   The animation itself is pure CSS transitions in both directions — no
   per-frame style writes, so nothing can jitter. Panels link to their
   persona on the Setups page.
   Desktop timing (17 Aug 2026): the pinned branch used to hold the intact
   photo for the first 22% of the pinned scroll range before anything
   moved, which on a 200vh-tall pin read as "the page is stuck" — shortened
   the hold and compressed the whole sequence so the crack starts almost as
   soon as you start scrolling past the photo. */
(function(){
  const stage=document.getElementById('journey-stage');
  if(!stage) return;
  const pin=document.getElementById('journey-pin');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const panels=[...stage.querySelectorAll('.jp')];
  const jp1=stage.querySelector('.jp-1'), jp3=stage.querySelector('.jp-3');

  if(reduced){
    if(pin) pin.style.height='auto';
    stage.style.position='relative';
    stage.style.top='auto';
    stage.classList.add('active','reveal','jbreak');
    stage.style.gap='14px';
    panels.forEach(p=>{
      const prod=p.querySelector('.jp-product');
      const card=p.querySelector('.jp-card');
      if(prod) prod.style.opacity=1;
      if(card) card.style.opacity=1;
    });
    return;
  }

  /* mobile / stacked: class toggle at two thresholds, CSS does the rest.
     Break when the stage top rises past 55% of the viewport; recompose when
     it drops back below 78%. The stage TOP is unaffected by the height the
     break adds below it, and the 23vh hysteresis gap is far wider than any
     URL-bar viewport resize, so the toggle can never oscillate. */
  if(matchMedia('(max-width: 1000px)').matches){
    let broken=false, mTick=false;
    const mUpdate=function(){
      mTick=false;
      const top=stage.getBoundingClientRect().top, vh=innerHeight;
      if(!broken && top < vh*0.55){
        broken=true;
        stage.classList.add('active','reveal','jbreak');
      } else if(broken && top > vh*0.78){
        broken=false;
        stage.classList.remove('active','reveal','jbreak');
      }
    };
    const mScroll=function(){ if(!mTick){ mTick=true; requestAnimationFrame(mUpdate); } };
    window.addEventListener('scroll',mScroll,{passive:true});
    window.addEventListener('resize',mScroll);
    window.addEventListener('load',mUpdate);
    mUpdate();
    return;
  }

  const clamp=(v,a,b)=>Math.max(0,Math.min(1,(v-a)/(b-a)));
  let ticking=false;
  function update(){
    ticking=false;
    const vh=innerHeight;
    const pinned=pin && getComputedStyle(stage).position==='sticky';
    let p;
    if(pinned){
      /* stage is pinned inside the tall wrapper — progress = how far
         through the pinned stretch you've scrolled */
      const pr=pin.getBoundingClientRect();
      const stickyTop=parseFloat(getComputedStyle(stage).top)||120;
      const range=Math.max(1,pin.offsetHeight-stage.offsetHeight-28);
      p=Math.max(0,Math.min(1,(stickyTop-pr.top)/range));
    } else {
      const rect=stage.getBoundingClientRect();
      p=Math.max(0,Math.min(1,(vh*0.95-rect.top)/(vh*0.95-vh*0.18)));
    }

    let scaleP,crackP,swapP,cardP;
    if(pinned){
      /* short hold (0–6%) so the photo registers, then it moves quickly:
         eases smaller, cracks into three, swaps to the machines and the
         card text is in by ~68% through the pinned scroll — the rest of
         the range is just a settled beat before it unpins. */
      scaleP=clamp(p,0.06,0.20);  /* then it eases slightly smaller */
      crackP=clamp(p,0.16,0.42);  /* then cracks into three */
      swapP =clamp(p,0.26,0.52);  /* slices become the machines */
      cardP =clamp(p,0.38,0.68);  /* text fades in last */
    } else {
      /* stacked but not mobile-width (rare): simple scrubbed sequence */
      scaleP=0;
      crackP=clamp(p,0.35,0.72);
      swapP =clamp(p,0.48,0.85);
      cardP =clamp(p,0.62,0.95);
    }

    stage.classList.toggle('active',crackP>0.01);
    stage.classList.toggle('reveal',swapP>0.9);
    stage.style.transform=scaleP>0?'scale('+(1-0.05*scaleP).toFixed(3)+')':'';

    const vertical=getComputedStyle(stage).flexDirection==='column';
    stage.style.gap=(crackP*(vertical?18:16))+'px';
    const stagger=vertical?'none':`translateY(${(-12*crackP).toFixed(1)}px)`;
    if(jp1) jp1.style.transform=stagger;
    if(jp3) jp3.style.transform=stagger;

    panels.forEach(pn=>{
      const prod=pn.querySelector('.jp-product');
      const card=pn.querySelector('.jp-card');
      if(prod) prod.style.opacity=swapP;
      if(card) card.style.opacity=cardP;
    });
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  window.addEventListener('load',update);
  update();
})();

/* hero rotator + manual nav */
(function(){
  const slides=[...document.querySelectorAll('.hero-slide')];
  if(!slides.length) return;
  let i=Math.max(0,slides.findIndex(s=>s.classList.contains('on')));
  let timer=null;
  function go(step){
    slides[i].classList.remove('on');
    i=(i+step+slides.length)%slides.length;
    slides[i].classList.add('on');
  }
  function resetTimer(){
    clearInterval(timer);
    if(slides.length>1 && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      timer=setInterval(()=>go(1),4500);
    }
  }
  window.heroNav=function(step){ go(step); resetTimer(); };
  resetTimer();
  const heroEl=document.querySelector('.hero');
  if(heroEl){
    heroEl.addEventListener('mouseenter',()=>clearInterval(timer));
    heroEl.addEventListener('mouseleave',resetTimer);
  }
})();

/* Profile picker: three real example setups (Ritual / Crowd / Simple),
   each with 3 curated tiers. Replaces the old budget-slider builder —
   these are editorial picks pulled straight from the live catalogue
   (real names, specs, prices), not a computed recommendation, so every
   pairing shown is a genuine, in-stock combination. Shared between the
   homepage and the Setups page via snippets/sacg-profiles.liquid.
   Guarded on #profile-tabs so this is a no-op on every other page.
   Tier labels (15 Aug 2026): unified to Budget / Getting Serious / Extreme
   across all three profiles, replacing the old per-profile tier names
   ("First steps", "Small office", "One box", etc.) so the tier control
   reads consistently no matter which style is selected.
   Selection tracking (15 Aug 2026): every paint() also writes the current
   pick to window.sacgSetupSelection.
   Real variant ids (18 Aug 2026): each pick's mVariantId/gVariantId is the
   real Shopify variant behind that machine/grinder — looked up against the
   live catalogue and matched by price against this file's existing
   mPrice/gPrice (every one matched exactly, confirming these picks really
   were pulled from real products as the comment above always said). Feeds
   "Make it yours" → addSetupToCart above, which adds both straight to the
   real cart. gVariantId is left unset for Meraki (the one genuine all-in-one
   pick, built-in grinder, single SKU) and for Couplux (also a single SKU —
   its own product page bundles a real Couplux Q20 grinder with the machine
   at one price, so there's no separate grinder variant to add to cart).
   Two-up stage image (18 Aug 2026 founder request): when a pick has gImg
   (a real product photo for the grinder, same source as gVariantId above),
   paint() shows both the machine and grinder photos side by side with a
   bronze + between them (#profile-bob gets .duo, see sacg-theme.css).
   Couplux correction (18 Aug 2026): it does NOT have the grinder built into
   the machine — its own product listing (couplux-cp239-coffee-machine-and-
   grinder) confirms it's a genuine machine + Couplux Q20 grinder set, just
   sold as one SKU/price with no separate grinder-only product photo to
   pair it with. So it keeps the single-image treatment (using that
   listing's real main photo, not a generic placeholder) while still
   showing the grinder's real name in the price breakdown below, rather
   than the generic "Grinder included / Built into the machine" copy that
   Meraki (the only true all-in-one pick) still uses. */
(function(){
  const tabsEl=document.getElementById("profile-tabs");
  if(!tabsEl) return;
  const fmt=v=>"R"+v.toLocaleString("en-ZA");
  const CDN="https://cdn.shopify.com/s/files/1/0753/8553/6546/files/";
  const TIER_NAMES=["Budget","Getting Serious","Extreme"];

  const PROFILES={
    ritual:{
      label:"The Ritual",
      tiers:TIER_NAMES,
      picks:[
        {mName:"Lelit Victoria",mSpec:"Dual boiler · PID entry",mPrice:18995,mVariantId:43893862891554,
          img:CDN+"lelit-victoria-espresso-machine-front-FINAL_grande_ab4c5a6c-685b-452a-bbd9-7022ea90c93c.webp?v=1750162884",
          gName:"Timemore Bricks 01S",gSpec:"Single-dose · entry",gPrice:5999,gVariantId:43891831210018,
          gImg:CDN+"FrontSide.webp?v=1750163037",
          why:"Dual boiler, real PID — and a single-dose grinder from day one. The ritual starts honestly, not with a compromise."},
        {mName:"Lelit Bianca V3",mSpec:"Dual boiler · flow paddle · E61",mPrice:54995,mVariantId:43109195055138,
          img:CDN+"Biancasilwerstraight_dfb5595d-fb18-42e2-b18e-8efb80952e20.png?v=1750779227",
          gName:"Presso DF64 Gen2",gSpec:"Single-dose · 64mm flat",gPrice:9995,gVariantId:45417734799394,
          gImg:CDN+"Presso_df64_black1_1024x1024_f9dd19c8-8263-48f2-8efd-ab90b1464a0f.webp?v=1779360817",
          why:"Flow profiling on the paddle, single-dose precision below it. This is where the ritual stops being a hobby."},
        {mName:"La Marzocco GS3 MP",mSpec:"Manual paddle",mPrice:153933,mVariantId:45797220483106,
          img:CDN+"La-Marzocco-GS3-AV-1024x1024_grande_3dad87eb-7411-4b64-86d0-6892c19cce93.webp?v=1781895477",
          gName:"Timemore Sculptor 078S",gSpec:"Single-dose · flat burr",gPrice:20899,gVariantId:43109302108194,
          gImg:CDN+"2218b0223bfebfb7baca19d71afe89db.png?v=1759646279",
          why:"Manual paddle, single-dose flat burr. You control every variable — nothing decides for you."}
      ]
    },
    crowd:{
      label:"The Crowd",
      tiers:TIER_NAMES,
      picks:[
        {mName:"Petrus PE3922 Max",mSpec:"Modern home espresso · PID",mPrice:30400,mVariantId:46052770676770,
          img:CDN+"ChatGPTImageJul20_2026_01_11_11PM_2.png?v=1784546165",
          gName:"Petrus PE3799",gSpec:"Entry espresso grinder",gPrice:5500,gVariantId:46054956400674,
          gImg:CDN+"ChatGPTImageJul20_2026_09_35_30PM.png?v=1784578297",
          why:"Push-button and quick to recover — keeps up with a small office queue without drama."},
        {mName:"Rocket Cinquantotto R58",mSpec:"Dual boiler · dual PID · E61",mPrice:76360,mVariantId:43493242503202,
          img:CDN+"R58.webp?v=1739006851",
          gName:"Fiorenzato AllGround Sense",gSpec:"Grind-by-weight · on demand",gPrice:18285,gVariantId:43299117334562,
          gImg:CDN+"Fiorenzato-Allground-Sense-black-matt-2-2.jpg?v=1727587546",
          why:"Dual boiler, dual PID, grind-by-weight dosing — built to keep pouring, back-to-back, all morning."},
        {mName:"La Marzocco GS3 AV",mSpec:"Automatic · volumetric dosing",mPrice:149303,mVariantId:45797220450338,
          img:CDN+"La-Marzocco-GS3-AV-1024x1024_grande_3dad87eb-7411-4b64-86d0-6892c19cce93.webp?v=1781895477",
          gName:"Mahlkönig E64WS",gSpec:"Grind-by-sync · shop grade",gPrice:25850,gVariantId:45308624371746,
          gImg:CDN+"E64-WS-Front-square_1750x1750_grande_37afea20-a027-43df-8811-6ec5015c305c.webp?v=1777479189",
          why:"Volumetric dosing and a shop-grade Mahlkönig. Built for the days the queue doesn't stop."}
      ]
    },
    simple:{
      label:"Simple",
      tiers:TIER_NAMES,
      picks:[
        {mName:"Couplux CP239",mSpec:"Semi-automatic · grinder included",mPrice:9950,mVariantId:44524994134050,
          img:CDN+"IMG_4375.heic?v=1763929811&format=webp",
          gName:"Couplux Q20 Grinder",gSpec:"Included in the set",gPrice:0,
          why:"The CP239 paired with its own Couplux Q20 grinder, sold as one set. Flip the switch, pull a shot — nothing else to figure out."},
        {mName:"Meraki",mSpec:"Smart all-in-one · built-in grinder",mPrice:55200,mVariantId:44473041387554,
          img:CDN+"MerakiFront.webp?v=1761817163",
          gName:null,gSpec:null,gPrice:0,
          why:"Built-in grinder, touch-screen recipes. Press a button, get a great shot, every single time."},
        {mName:"La Marzocco Linea Mini R",mSpec:"Compact café machine",mPrice:106737,mVariantId:45797272944674,
          img:CDN+"la-marzocco-linea-mini-r-chrome-slight-turn-hero-shot-FINAL_1024x1024_7c17850f-6820-4086-859e-ddcd7dfd4d6c.webp?v=1781896535",
          gName:"Mahlkönig E64WS",gSpec:"Grind-by-sync · on demand",gPrice:25850,gVariantId:45308624371746,
          gImg:CDN+"E64-WS-Front-square_1750x1750_grande_37afea20-a027-43df-8811-6ec5015c305c.webp?v=1777479189",
          why:"Café-grade Linea Mini R with a Mahlkönig that syncs the dose. Effortless, endgame, done."}
      ]
    }
  };

  const requestedProfile=new URLSearchParams(location.search).get("profile");
  let activeProfile=(requestedProfile && PROFILES[requestedProfile]) ? requestedProfile : "ritual", activeTier=0;
  const tierSeg=document.getElementById("profile-tier-seg");
  const tierBtns=[...tierSeg.querySelectorAll("button")];
  const img=document.getElementById("profile-stage-img");
  const gimg=document.getElementById("profile-stage-gimg");
  const plusEl=document.getElementById("profile-plus");
  const bobEl=document.getElementById("profile-bob");

  function paint(){
    const p=PROFILES[activeProfile], pick=p.picks[activeTier];
    img.src=pick.img; img.alt=pick.mName;
    if(pick.gImg){
      gimg.src=pick.gImg; gimg.alt=pick.gName;
      gimg.hidden=false; plusEl.hidden=false;
      bobEl.classList.add("duo");
    } else {
      /* Full reset, not just hidden=true (18 Aug 2026 founder report: single-
         image picks like Couplux/Meraki were rendering their machine photo
         shifted left, sitting where it'd be if a plus + second image
         followed it). The actual layout fix is the !important guard on
         #profile-stage-gimg[hidden] in sacg-theme.css (the global
         `img{display:block}` reset was beating the browser's own
         [hidden]{display:none} default, so the "hidden" img kept reserving
         its flex slot) — clearing src/classes here is just belt-and-braces
         so no stale image data or swap-transition state lingers on an
         element that's now guaranteed to be display:none regardless. */
      gimg.hidden=true; plusEl.hidden=true;
      gimg.classList.remove("swap-in","swap-out");
      gimg.removeAttribute("src");
      gimg.style.visibility="";
      bobEl.classList.remove("duo");
    }
    document.getElementById("profile-m-name").textContent=pick.mName;
    document.getElementById("profile-m-spec").textContent=pick.mSpec;
    document.getElementById("profile-m-price").textContent=fmt(pick.mPrice);
    if(pick.gName){
      document.getElementById("profile-g-name").textContent=pick.gName;
      document.getElementById("profile-g-spec").textContent=pick.gSpec;
      /* gPrice 0 (Couplux 18 Aug 2026 correction): the grinder is a real,
         separate device — a Couplux Q20 — not built into the machine, but
         it's sold as one SKU at one price, so there's no extra line-item
         cost to show. "Included" reads correctly here; fmt(0) would show
         the wrong thing ("R0"). */
      document.getElementById("profile-g-price").textContent=pick.gPrice?fmt(pick.gPrice):"Included";
    } else {
      document.getElementById("profile-g-name").textContent="Grinder included";
      document.getElementById("profile-g-spec").textContent="Built into the machine";
      document.getElementById("profile-g-price").textContent="Included";
    }
    document.getElementById("profile-why").textContent=pick.why;
    const totalStr=fmt(pick.mPrice+(pick.gPrice||0));
    document.getElementById("profile-total").textContent=totalStr;
    document.getElementById("profile-tier-label").textContent=p.label+" · "+p.tiers[activeTier];
    window.sacgSetupSelection={
      profile:p.label,
      tier:p.tiers[activeTier],
      machine:pick.mName,
      grinder:pick.gName||null,
      total:totalStr,
      mVariantId:pick.mVariantId||null,
      gVariantId:pick.gVariantId||null
    };
  }

  function render(swap){
    const p=PROFILES[activeProfile];
    tabsEl.querySelectorAll(".profile-tab").forEach(b=>b.classList.toggle("on",b.dataset.profile===activeProfile));
    tierBtns.forEach((b,i)=>{ b.textContent=p.tiers[i]; b.classList.toggle("on",i===activeTier); });

    if(!swap){ paint(); return; }
    img.classList.add("swap-out");
    const gWasVisible=!gimg.hidden;
    if(gWasVisible) gimg.classList.add("swap-out");
    setTimeout(()=>{
      paint();
      img.classList.remove("swap-out");
      img.classList.add("swap-in");
      const gNowVisible=!gimg.hidden;
      if(gNowVisible){ gimg.classList.remove("swap-out"); gimg.classList.add("swap-in"); }
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        img.classList.remove("swap-in");
        if(gNowVisible) gimg.classList.remove("swap-in");
      }));
    },260);
  }

  tabsEl.querySelectorAll(".profile-tab").forEach(b=>b.addEventListener("click",()=>{
    if(b.dataset.profile===activeProfile) return;
    activeProfile=b.dataset.profile; activeTier=0; render(true);
  }));
  tierBtns.forEach((b,i)=>b.addEventListener("click",()=>{
    if(i===activeTier) return;
    activeTier=i; render(true);
  }));

  render(false);
})();

/* events page: inquiry form + live snapshot.
   Guarded on #ev-event-seg so this is a no-op everywhere else. */
(function(){
  const seg=document.getElementById("ev-event-seg");
  if(!seg) return;
  const cards=document.querySelectorAll(".ev-type-card");
  const budgetSeg=document.getElementById("ev-budget-seg");
  const dateEl=document.getElementById("ev-date");
  const guestsEl=document.getElementById("ev-guests");
  const locEl=document.getElementById("ev-location");
  const detailsEl=document.getElementById("ev-details");
  let eventType="Other", eventBudget="Not sure yet";

  function setEventType(v,btn){
    eventType=v;
    seg.querySelectorAll("button").forEach(b=>b.classList.toggle("on",b===btn));
    cards.forEach(c=>c.classList.toggle("on",c.dataset.event===v));
    updateSnapshot();
  }
  seg.querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>setEventType(b.dataset.v,b)));
  cards.forEach(c=>c.addEventListener("click",()=>{
    const v=c.dataset.event;
    const btn=[...seg.querySelectorAll("button")].find(b=>b.dataset.v===v);
    setEventType(v,btn);
    document.getElementById("ev-inquiry").scrollIntoView({behavior:"smooth"});
  }));
  if(budgetSeg){
    budgetSeg.querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>{
      budgetSeg.querySelectorAll("button").forEach(x=>x.classList.remove("on"));
      b.classList.add("on");eventBudget=b.dataset.v;updateSnapshot();
    }));
  }

  function updateSnapshot(){
    document.getElementById("ev-snap-type").textContent=eventType;
    const dv=dateEl.value;
    document.getElementById("ev-snap-date").textContent=dv?new Date(dv+"T00:00:00").toLocaleDateString("en-ZA",{day:"numeric",month:"short",year:"numeric"}):"—";
    const g=+guestsEl.value||0;
    document.getElementById("ev-snap-guests").textContent=g?g+" guests":"—";
    document.getElementById("ev-snap-location").textContent=locEl.value||"—";
    document.getElementById("ev-snap-budget").textContent=eventBudget;
  }
  [dateEl,guestsEl,locEl].forEach(el=>el.addEventListener("input",updateSnapshot));
  updateSnapshot();

  const form=document.querySelector(".ev-form");
  if(form){
    form.addEventListener("submit",()=>{
      detailsEl.value=`EVENT INQUIRY\nType: ${eventType}\nDate: ${dateEl.value||"—"}\nGuests: ${guestsEl.value||"—"}\nLocation: ${locEl.value||"—"}\nBudget: ${eventBudget}\n\nDetails:\n${detailsEl.value||"—"}`;
    });
  }
})();

/* Shop mega-menu: click-only (18 Aug 2026 — was hover-to-open, replaced
   after founder feedback; see the CSS comment on .nav-drop-btn::after for
   why). This toggles .nav-drop.open, which the CSS in sacg-theme.css uses
   to both show the panel and flip the +/- indicator next to "Shop". Also
   closes on an outside click or Escape. Header renders on every page, so
   this is guarded and safe everywhere. */
(function(){
  const btn=document.getElementById("shop-drop-btn");
  const drop=btn ? btn.closest(".nav-drop") : null;
  if(!btn||!drop) return;
  function close(){ drop.classList.remove("open"); btn.setAttribute("aria-expanded","false"); }
  function toggle(){
    const willOpen=!drop.classList.contains("open");
    drop.classList.toggle("open",willOpen);
    btn.setAttribute("aria-expanded",willOpen?"true":"false");
  }
  btn.addEventListener("click",e=>{ e.stopPropagation(); toggle(); });
  document.addEventListener("click",e=>{ if(!drop.contains(e.target)) close(); });
  document.addEventListener("keydown",e=>{ if(e.key==="Escape") close(); });
})();

/* Product card hover image swap (18 Aug 2026 founder request): hovering any
   .m-card that has a second product image swaps its .m-img photo to that
   image, reverting when the pointer leaves. Delegated on document (rather
   than bound per-card) so it also catches cards built dynamically by the
   product-recommendations script on product pages ("Pairs well with this"),
   which don't exist in the DOM until that fetch resolves. The second-image
   URL is read from data-hover-src, set server-side by Liquid on rendered
   grids (collection/search/homepage/related) or client-side by the
   recommendations script — cards with only one photo simply have no
   data-hover-src and are left alone. Skipped entirely on touch-only
   devices, which have no hover state to trigger this from. */
(function(){
  if(matchMedia('(hover: none)').matches) return;
  document.addEventListener('mouseover',function(e){
    var card=e.target.closest && e.target.closest('.m-card');
    if(!card) return;
    var img=card.querySelector('.m-img img');
    if(!img || !img.dataset.hoverSrc) return;
    if(!img.dataset.origSrc) img.dataset.origSrc=img.getAttribute('src')||'';
    img.src=img.dataset.hoverSrc;
  });
  document.addEventListener('mouseout',function(e){
    var card=e.target.closest && e.target.closest('.m-card');
    if(!card) return;
    if(e.relatedTarget && card.contains(e.relatedTarget)) return; /* still inside the same card */
    var img=card.querySelector('.m-img img');
    if(!img || !img.dataset.origSrc) return;
    img.src=img.dataset.origSrc;
  });

  /* Preload hover images (18 Aug 2026 founder feedback: the first hover on
     a given product visibly paused before the photo changed). The swap
     above just points .src at data-hover-src — the very first time that
     happens for a card, the browser has never fetched that image before,
     so it has to go to the network and the swap stalls until it arrives.
     Every hover after is instant purely because the browser's own cache
     already has it. Warming that cache ahead of time — quietly fetching
     each card's second photo in the background before the user ever
     hovers — removes the pause. Exposed as window.sacgPreloadHoverImages
     so the "Pairs well with this" recommendations script on product pages
     (sections/sacg-product-page.liquid) can call it right after building
     its own cards, since those don't exist yet at page load and would
     otherwise miss the pass below entirely. */
  window.sacgPreloadHoverImages=function(root){
    (root||document).querySelectorAll('.m-img img[data-hover-src]').forEach(function(img){
      if(img.dataset.hoverPreloaded) return;
      img.dataset.hoverPreloaded='1';
      var pre=new Image();
      pre.src=img.dataset.hoverSrc;
    });
  };
  /* Runs after the page has fully loaded, and where supported waits for an
     idle moment on top of that, so this never competes for bandwidth with
     the images actually needed for first paint — it only needs to beat the
     user's first hover, which is always at least a moment after load. */
  function scheduleHoverPreload(){
    if(window.requestIdleCallback) requestIdleCallback(function(){ window.sacgPreloadHoverImages(); },{timeout:2000});
    else setTimeout(function(){ window.sacgPreloadHoverImages(); },300);
  }
  if(document.readyState==='complete') scheduleHoverPreload();
  else window.addEventListener('load',scheduleHoverPreload);
})();

/* Header search: real GET form to Shopify's native search page (works with
   JS off), enhanced with a live predictive-search dropdown. Header renders
   on every page, so this is guarded and safe everywhere.
   Mobile note (15 Aug 2026): focus() used to be wrapped in a setTimeout,
   which on iOS/Android WebKit falls outside the click event's "user
   activation" window — the overlay opened but the on-screen keyboard never
   raised, so people had to tap the input a second time. Focusing
   synchronously inside the click handler, in the same tick that shows the
   overlay, keeps it inside that window and raises the keyboard immediately. */
(function(){
  const triggers=[...document.querySelectorAll(".search-open-btn")];
  const overlay=document.getElementById("search-overlay");
  if(!triggers.length||!overlay) return;
  const primaryBtn=document.getElementById("site-search-btn");
  const closeBtn=document.getElementById("search-close");
  const input=document.getElementById("site-search-input");
  const results=document.getElementById("search-results");

  function open(){
    overlay.classList.add("open");
    if(primaryBtn) primaryBtn.setAttribute("aria-expanded","true");
    input.focus();
    input.select();
  }
  function close(){
    overlay.classList.remove("open");
    if(primaryBtn) primaryBtn.setAttribute("aria-expanded","false");
  }
  triggers.forEach(btn=>btn.addEventListener("click",open));
  closeBtn.addEventListener("click",close);
  overlay.addEventListener("click",e=>{ if(e.target===overlay) close(); });
  document.addEventListener("keydown",e=>{ if(e.key==="Escape" && overlay.classList.contains("open")) close(); });

  let debounceTimer=null, currentQuery="";
  input.addEventListener("input",()=>{
    const q=input.value.trim();
    clearTimeout(debounceTimer);
    if(q.length<2){ results.innerHTML=""; currentQuery=""; return; }
    debounceTimer=setTimeout(()=>fetchResults(q),220);
  });

  function fetchResults(q){
    currentQuery=q;
    const root=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url=root.replace(/\/$/,"")+"/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last";
    fetch(url).then(r=>r.json()).then(data=>{
      if(q!==currentQuery) return; /* a newer keystroke already superseded this request */
      const products=(data.resources && data.resources.results && data.resources.results.products) || [];
      if(!products.length){
        results.innerHTML='<div class="search-empty">No matches for "'+q.replace(/</g,"&lt;")+'". Try a different name, or browse <a href="/collections/coffee-machines">all machines</a>.</div>';
        return;
      }
      results.innerHTML=products.map(p=>{
        const img=p.featured_image && p.featured_image.url;
        const alt=(p.featured_image && p.featured_image.alt) || p.title;
        return '<a class="search-hit" href="'+p.url+'">'
          +(img?'<img src="'+img+'" alt="'+alt.replace(/"/g,"&quot;")+'" loading="lazy">':'<span class="search-hit-noimg"></span>')
          +'<div class="search-hit-body"><b>'+p.title+'</b><span>'+(p.type||"")+'</span></div></a>';
      }).join("");
    }).catch(()=>{
      results.innerHTML='<div class="search-empty">Live search isn\'t responding right now — press Enter to see full results.</div>';
    });
  }
})();

/* Combos page: budget-tier filter + grid/compare view toggle.
   Guarded on #combo-tier-seg so this is a no-op everywhere else. */
(function(){
  const tierSeg=document.getElementById("combo-tier-seg");
  if(!tierSeg) return;
  const cards=[...document.querySelectorAll("#combo-cards .combo-card")];
  const rows=[...document.querySelectorAll("#combo-compare-wrap tbody tr")];
  const emptyMsg=document.getElementById("combo-tier-empty");

  function inTier(price,tier){
    if(tier==="all") return true;
    if(tier==="starter") return price<15000;
    if(tier==="enthusiast") return price>=15000 && price<50000;
    if(tier==="endgame") return price>=50000;
    return true;
  }
  function applyTier(tier){
    let visible=0;
    cards.forEach(c=>{
      const show=inTier(+c.dataset.price||0,tier);
      c.classList.toggle("combo-hidden",!show);
      if(show) visible++;
    });
    rows.forEach(r=>r.classList.toggle("combo-hidden",!inTier(+r.dataset.price||0,tier)));
    if(emptyMsg) emptyMsg.hidden=visible>0;
  }
  tierSeg.querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>{
    tierSeg.querySelectorAll("button").forEach(x=>x.classList.remove("on"));
    b.classList.add("on");
    applyTier(b.dataset.tier);
  }));

  const viewToggle=document.getElementById("combo-view-toggle");
  const gridEl=document.getElementById("combo-cards");
  const compareEl=document.getElementById("combo-compare-wrap");
  if(viewToggle && gridEl && compareEl){
    viewToggle.querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>{
      viewToggle.querySelectorAll("button").forEach(x=>x.classList.remove("on"));
      b.classList.add("on");
      const isCompare=b.dataset.view==="compare";
      gridEl.hidden=isCompare;
      compareEl.hidden=!isCompare;
    }));
  }
})();
